module.exports = __webpack_public_path__ + "static/media/jupiter.be7e0851.svg";